import { render, staticRenderFns } from "./AccountDialog.vue?vue&type=template&id=5b24d8ab&scoped=true&"
import script from "./AccountDialog.vue?vue&type=script&lang=js&"
export * from "./AccountDialog.vue?vue&type=script&lang=js&"
import style0 from "./AccountDialog.vue?vue&type=style&index=0&id=5b24d8ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b24d8ab",
  null
  
)

export default component.exports